import React, { memo } from 'react';
import { Target, Users, Award } from 'lucide-react';
const About = () => {
  return <section id="nosotros" className="py-16 md:py-24 bg-gray-50" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-promred-gray mb-4" data-id="element-18">
            Sobre Nosotros
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-19">
            En Promred nos especializamos en crear y gestionar soluciones que
            fortalecen la relación entre empresas y sus clientes.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-20">
          <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-21">
            <div className="w-16 h-16 bg-promred-red bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-22">
              <Target className="text-promred-red" size={28} data-id="element-23" />
            </div>
            <h3 className="text-xl font-bold text-promred-gray mb-3" data-id="element-24">Misión</h3>
            <p className="text-gray-600" data-id="element-25">
              Proporcionar soluciones innovadoras de gestión de eventos que
              generen valor para nuestros clientes y sus usuarios.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-26">
            <div className="w-16 h-16 bg-promred-blue bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-27">
              <Users className="text-promred-blue" size={28} data-id="element-28" />
            </div>
            <h3 className="text-xl font-bold text-promred-gray mb-3" data-id="element-29">Visión</h3>
            <p className="text-gray-600" data-id="element-30">
              Ser líderes en la creación de experiencias memorables que
              fortalezcan las relaciones entre empresas y sus clientes.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md text-center" data-id="element-31">
            <div className="w-16 h-16 bg-promred-orange bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-32">
              <Award className="text-promred-orange" size={28} data-id="element-33" />
            </div>
            <h3 className="text-xl font-bold text-promred-gray mb-3" data-id="element-34">
              Valores
            </h3>
            <p className="text-gray-600" data-id="element-35">
              Innovación, compromiso, excelencia y orientación al cliente son
              los valores que guían nuestro trabajo diario.
            </p>
          </div>
        </div>
        <div className="bg-white p-8 md:p-12 rounded-lg shadow-md" data-id="element-36">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-37">
            <div className="md:w-1/2" data-id="element-38">
              <h3 className="text-2xl font-bold text-promred-gray mb-4" data-id="element-39">
                Nuestra Historia
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-40">
                Promred nació con la visión de transformar la manera en que las
                empresas, instituciones y organizaciones se relacionan con sus
                clientes o grupos de interés. A lo largo de los años, hemos
                evolucionado para ofrecer soluciones integrales que combinan
                estrategia, tecnología y creatividad.
              </p>
              <p className="text-gray-600" data-id="element-41">
                Hoy en día, somos reconocidos por nuestra capacidad para
                gestionar eventos memorables que generan resultados tangibles
                para nuestros clientes.
              </p>
            </div>
            <div className="md:w-1/2" data-id="element-42">
              <div className="rounded-lg overflow-hidden shadow-md" data-id="element-43">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rSvk1tFDYgF4hzPLvjZVGc/image.png" alt="Personas usando la aplicación de Promred" className="w-full h-auto object-cover" data-id="element-44" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default About;